import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

const MainLayout = lazy(() => import('newApp/layouts/main-layout/MainLayout'));
const NotFoundPage = lazy(() => import('./pages/not-found/NotFoundPage'));

const errorRoutes = [
  {
    element: <MainLayout />,
    children: [
      {
        path: '/error/404',
        element: <NotFoundPage />,
        handle: {
          hidePageHeader: true,
          title: 'pageNotFound',
        },
      },
      {
        path: '*',
        element: <Navigate replace to="/error/404" />,
      },
    ],
  },
];

export default errorRoutes;
